import React from 'react';
import './Chapters.scss';

function Chapter10() {
  return (
    <section className="chapter">
      <p className="chapter__title">
        Nasdaq: Transforming Capital Markets with Trading Systems in the Cloud
      </p>
      <p className="chapter__paragraph">
        <a
          href="https://www.nasdaq.com/"
          target="_blank"
          rel="noreferrer"
          className="chapter__paragraph__link"
        >
          Nasdaq
        </a>{' '}
        is a global technology company serving the capital markets and other industries, driven by a
        distinct purpose: to champion inclusive growth and prosperity and to reimagine markets to
        realize tomorrow's potential. This is all thanks to Nasdaq’s trading systems, which are
        responsible for seamlessly transacting hundreds of billions of dollars a day serving
        millions of investors globally. To successfully execute this activity, the underlying market
        infrastructure needs to be highly scalable, resilient, and performant with extremely low
        latency. Nasdaq is in a multi-year partnership with Amazon Web Services to migrate its core
        markets to AWS and will use a new low-latency edge computing solution that is co-designed
        specifically for these market infrastructure unique requirements. The edge computing
        solution also involves Nasdaq incorporating AWS Outposts directly into its core network to
        deliver the first-ever Private Local Zone for the capital markets industry within Nasdaq’s
        primary data center in Carteret, New Jersey.
      </p>
      <p className="chapter__paragraph">
        This edge computing solution will allow Nasdaq to have low-latency access to its on-premises
        systems for clients, while leveraging AWS's cloud capabilities to deliver innovative
        anti-financial crime, data and analytics, and market infrastructure software solutions to
        its global clients. Nasdaq is committed to creating an interconnected future—one that is
        safer and stronger for everyone, in the cloud.
      </p>
    </section>
  );
}

export default Chapter10;
